@if (initialized && formGroup) {


  <div class="grid" [formGroup]="formGroup">

    <div class="col-12">
      <label for="phone" class="font-medium text-900 mb-2 block">Telefonnummer</label>
      <span class="p-input-icon-left block">
            <i class="flex gap-2 text-primary line-height-1 font-medium" style="font-style: normal;">
              <div class="flag-container">
              <div class="stripe black"></div>
              <div class="stripe red"></div>
              <div class="stripe gold"></div>
              </div>+49</i>
                  <input [style]="{'padding-left': '6rem', width: '100%'}" pInputText id="phone"
                         minlength="8" formControlName="phone" />
      </span>
    </div>

    <div class="col-12">
      <label for="password" class="font-medium text-900 mb-2 block">Passwort</label>
      <p-password id="password" formControlName="password"
                  autoComplete="new-password"
                  placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                  [toggleMask]="true" [feedback]="false"></p-password>
    </div>

  </div>

  <div class="flex justify-content-end">
<!--    <button class="w-10rem" pButton [disabled]="!formGroup.valid" (click)="updateEmail()" pRipple-->
<!--            label="Speichern"></button>-->

    <app-button [busy]="busy"
                [disabled]="!formGroup.valid"
                [label]="'Speichern'"
                [class]="'w-10rem'"
                [showIcon]="false"
                (onClick)="updatePhone()">
    </app-button>
  </div>


}
